module.exports = __webpack_public_path__ + "02_medium_black.0096acc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_medium_black.png
// module id = a5CS
// module chunks = 0